import React from "react";
import { motion } from "framer-motion";
import "./Occupational.css";

function Occupational() {
  return (
    <>
      <h2 className="occupational-therapy">Occupational Therapy</h2>
      <motion.div
        initial={{ x: -100, opacity: 0 }} // Start position (off-screen left)
        animate={{ x: 0, opacity: 1 }} // End position (on-screen)
        transition={{ duration: 1 }} // Animation duration
      >
        <div></div>
        <div className="container">
          <p>
            Occupational Therapy is given to children who have difficulties with
            the practical and social skills. It targets challenges in gross
            motor skills (e.g., walking, jumping), fine motor skills (e.g., hand
            dexterity), sensory integration, and self-care tasks (daily
            dressing, feeding, grooming and hygienic tasks). Occupational
            Therapy is delivered individually and in groups, using diverse
            resources like peg boards, play dough, and soft toys. Experts
            regularly visit to supervise activities and conduct seminars for
            staff and parents.
          </p>
        </div>
      </motion.div>
    </>
  );
}

export default Occupational;
